export const GET_USER_EXTENSIONS = "GET_USER_EXTENSIONS"
export const SAVE_USER_EXTENSIONS = "SAVE_USER_EXTENSIONS"
export const GET_EXTENSION_LIST = "GET_EXTENSION_LIST"
export const EDIT_EXTENSION_API = "EDIT_EXTENSION_API"
export const CREATE_EXTENSION_API = "CREATE_EXTENSION_API"
export const DELETE_EXTENSION_API = "DELETE_EXTENSION_API"
export const SAVE_EXTENSIONS = "SAVE_EXTENSIONS"